"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
var videoPlayer; // Video Popup

var vimeoScript = document.createElement('script');
var videoPopup = document.createElement('div');
var videoPopupContent = document.createElement('div');
var videoPopupHeader = document.createElement('div'); // const videoIframe = document.createElement('iframe');

var videoContainer = document.createElement('div');
var videoCloseButton = document.createElement('button'); // Director Popup

var directorPopup = document.createElement('div');
var directorPopupContent = document.createElement('div');
var directorPopupHeader = document.createElement('div');
var directorCloseButton = document.createElement('button');
var mobileBP = 782;
videoCloseButton.innerHTML = '<svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="2.06066" y1="1.93934" x2="34.0607" y2="33.9393" stroke="#D9D9D9" stroke-width="3"/><line x1="1.93934" y1="33.9393" x2="33.9393" y2="1.93934" stroke="#D9D9D9" stroke-width="3"/></svg>';
directorCloseButton.innerHTML = videoCloseButton.innerHTML;
var eventMouseAdded = false;
document.addEventListener("DOMContentLoaded", function (e) {
  navigationInit();
  initVideoPopup();
  initDirectorPopup();
  gsapInit();
  directorGridInit(e);
  projectLoopInit();
  textAnimScroll();
});

function navigationInit() {
  var mainMenu = document.querySelector(".main-navigation");
  if (!mainMenu) return;
  var menuOpen = document.querySelector(".menu-open");
  var menuClose = document.querySelector(".menu-close");
  var linksWithChildren = mainMenu.querySelectorAll(".menu-item-has-children");
  menuOpen.addEventListener("click", function (e) {
    document.body.classList.add("menu-toggled");
    menuOpen.setAttribute("aria-expanded", true);
  });
  menuClose.addEventListener("click", function (e) {
    document.body.classList.remove("menu-toggled");
    menuClose.setAttribute("aria-expanded", false);
  });
  mainMenu.querySelectorAll('a[href*="/director"]').forEach(function (anchor, i) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      openDirectorPopup(anchor);
    });
  });
  linksWithChildren.forEach(function (link, i) {
    // console.log(link);
    var dropDown = document.createElement("button");
    var emptyAnchor = link.querySelector('a[href*="#"]');
    dropDown.className = "dropdown-toggle";
    dropDown.addEventListener("click", function (e) {
      link.classList.toggle("active");
    });
    link.append(dropDown);
    if (!emptyAnchor) return;
    emptyAnchor.addEventListener('click', function (e) {
      e.preventDefault();
      dropDown.click();
    });
  });
}

function gsapInit() {
  gsap.registerPlugin(ScrollToPlugin);
  gsap.registerPlugin(ScrollTrigger);
} // function horScroll() {
// 	console.log(window.outerWidth);
// 	if (window.outerWidth < 782) return;
// 	document.querySelectorAll('.directors-grid').forEach((el, i) => {
// 		console.log(el.scrollWidth - window.outerWidth);
// 		gsap.to(el, {
// 			x: (el.scrollWidth - window.outerWidth + 100) * -1,
// 			scrollTrigger: {
// 				trigger: el,
// 				scrub: 1.5,
// 				pin: true,
// 				end: (el.scrollWidth - window.outerWidth + 100) * .7,
// 			},
// 		});
// 	});
// }

/*--------------------------------------------------------------
## Test Director grid new
--------------------------------------------------------------*/


function directorGridInit(e) {
  var directorGrid = document.querySelector('.directors-grid');
  if (!directorGrid) return;
  var step = 500;
  var offsetX = 0;
  var offsetY = 0;
  var spiral = directorGrid.querySelector('.spiral path');
  var gridWrapper = directorGrid.querySelector('.grid-wrapper');
  var panningWrapper = directorGrid.querySelector('.panning-wrapper');
  var inactiveRegion = 150;
  var directors = gridWrapper.querySelectorAll('.director'); // Shuflle list based on priority

  var high = gridWrapper.querySelectorAll('[data-priority="high"]');
  var medium = gridWrapper.querySelectorAll('[data-priority="medium"]');
  var low = gridWrapper.querySelectorAll('[data-priority="low"]');
  var overflowX, mapPositionX, overflowY, mapPositionY;
  high = shuffle(_toConsumableArray(high));
  medium = shuffle(_toConsumableArray(medium));
  low = shuffle(_toConsumableArray(low));
  high.forEach(function (el, i) {
    gridWrapper.append(el);
  });
  medium.forEach(function (el, i) {
    gridWrapper.append(el);
  });
  low.forEach(function (el, i) {
    gridWrapper.append(el);
  });
  directors.forEach(function (item, i) {
    var perc = i / directors.length;
    setCoords(item, i);
    var link = item.querySelector('.link');
    link.addEventListener('click', function (e) {
      e.preventDefault();
      openDirectorPopup(link);
    });
  });
  spiral.parentNode.style.display = 'none';
  directorGrid.classList.add('ready');

  if (!isTouch()) {
    setPositions(directors);
    setGridWrapperWidths(); // setTimeout(() => {

    initPanning(); // }, 1000);
  }

  filterCountries();

  function setGridWrapperWidths() {
    gridWrapper.style.width = '';
    gridWrapper.style.height = '';
    gridWrapper.style.width = gridWrapper.scrollWidth + 'px';
    gridWrapper.style.height = gridWrapper.scrollHeight + 'px';
    gridWrapper.style.overflow = 'visible';
  }

  function setCoords(item, index) {
    // console.log('setpos!');
    var dist = step * index;
    var point = spiral.getPointAtLength(dist);
    item.dataset.top = getRandomArbitrary(point.y / 1.02, point.y);
    item.dataset.left = getRandomArbitrary(point.x / 1.02, point.x);
  }

  function setPositions(directors) {
    // console.log('set position', directors);
    var lowerLeft, lowerTop;
    var valuesLeft = [];
    var valuesTop = []; // console.log('filtered', directors);

    directors.forEach(function (item, i) {
      valuesTop.push(Number(item.dataset.top));
      valuesLeft.push(Number(item.dataset.left)); // item.style.width = item.scrollWidth + 'px';
      // item.style.height = item.scrollHeight + 'px';
    });
    lowerLeft = Math.min.apply(Math, valuesLeft);
    lowerTop = Math.min.apply(Math, valuesTop);
    directors.forEach(function (director, i) {
      // director.style.top = `${director.dataset.top - lowerTop  + director.clientHeight / 2}px`;
      // director.style.left = `${director.dataset.left - lowerLeft  + director.clientWidth / 2}px`;
      gsap.set(director, {
        top: "".concat(director.dataset.top - lowerTop, "px"),
        left: "".concat(director.dataset.left - lowerLeft, "px")
      });
      gsap.fromTo(director, {
        scale: 1.2
      }, {
        scale: 1,
        overwrite: true,
        duration: .5
      }, '< .02');
    });
  }
  /*--------------------------------------------------------------
  ## Paning
  --------------------------------------------------------------*/


  function onResize(e) {
    mapPositionX = gsap.utils.mapRange(offsetX, window.innerWidth - offsetX * 2, 0, (panningWrapper.clientWidth - window.innerWidth) * -1);
    mapPositionY = gsap.utils.mapRange(offsetY, window.innerHeight - offsetY * 2, 0, (panningWrapper.clientHeight - window.innerHeight) * -1);
  }

  function onMouseMove(e) {
    // let extraX = e.clientX - window.outerWidth / 2;
    // extraX = 0;
    var _x = e.clientX || e.changedTouches && e.changedTouches[0].clientX || 0; // x = x + extraX;
    // let extraY = e.clientY - window.outerHeight / 2;
    // extraY = 0;


    var _y = e.clientY || e.changedTouches && e.changedTouches[0].clientY || 0; // y = y + extraY;
    // console.log(mapPositionX(x), mapPositionY(y));


    gsap.to(panningWrapper, {
      duration: 2,
      overwrite: true,
      ease: "power4",
      x: function x() {
        return gsap.utils.clamp((panningWrapper.clientWidth - window.innerWidth + offsetX / 2) * -1, 0, mapPositionX(_x)); // return mapPositionX(x);
      },
      y: function y() {
        return gsap.utils.clamp((panningWrapper.clientHeight - window.innerHeight + offsetY / 2) * -1, 0, mapPositionY(_y)); // return mapPositionY(y);
      }
    });
  }

  function initPanning() {
    setTimeout(function () {
      gsap.set(panningWrapper, {
        duration: 2,
        overwrite: true,
        ease: "power4",
        x: (panningWrapper.clientWidth - window.innerWidth) / -2,
        y: (panningWrapper.clientHeight - window.innerHeight) / -2
      });
      window.addEventListener("resize", onResize);
      document.addEventListener("mousemove", onMouseMove);
      eventMouseAdded = true; // document.addEventListener("touchmove", onMouseMove);
      // document.addEventListener("pointermove", onMouseMove);

      onResize();
    }, 300);
  }
  /*--------------------------------------------------------------
  ## Filter Countries
  --------------------------------------------------------------*/


  function filterCountries() {
    var filter = document.querySelector('.filter-countries');
    if (!filter) return; // console.log(!filter);

    var directors = directorGrid.querySelectorAll('.director');
    var filterItems = filter.querySelectorAll('li');
    filterItems.forEach(function (el, i) {
      // console.log(i);
      if (!directorGrid.querySelectorAll("[data-countries *=\"".concat(el.dataset.country, "\"]")).length && !el.id) {
        // console.log(`${el.innerText} deleted`, el.id);
        el.remove();
      }

      el.addEventListener('click', function (e) {
        if (el.classList.contains('active')) return;
        var j = 0;
        filterItems.forEach(function (o) {
          // console.log(o);
          if (o == el) {
            o.classList.add('active');
          } else {
            o.classList.remove('active');
          }
        });

        if (el.id == 'all-countries') {
          directorGrid.classList.remove('filtered');

          if (!isTouch()) {
            directors.forEach(function (director, i) {
              setCoords(director, i);
            });
            setPositions(directors);
            setGridWrapperWidths();
            onResize(e);
            onMouseMove(e);
          }
        } else {
          directorGrid.classList.add('filtered');
          directors.forEach(function (director, i) {
            director.classList.remove('found');

            if (director.dataset.countries.indexOf(el.dataset.country) != -1) {
              director.classList.add('found');
              setCoords(director, j);
              j++;
            }
          });

          if (!isTouch()) {
            var founds = _toConsumableArray(directors).filter(function (item) {
              return item.dataset.countries.indexOf(el.dataset.country) != -1;
            });

            setPositions(founds);
            setGridWrapperWidths();
            onResize(e);
            onMouseMove(e); // gsap.set(gridWrapper, { overwrite: true, duration: 0, x: 0, y: 0 });
          }
        }
      });
    });
  } // Panning on director list (not working!)


  document.querySelectorAll('.main-navigation a[href*="/director"]').forEach(function (anchor, i) {
    var work = document.querySelector("div.director:has(a[href=\"".concat(anchor.href, "\"])"));
    anchor.addEventListener('mouseenter', function (e) {
      if (work) {
        work.classList.add('hover');
        var pwStyles = getComputedStyle(panningWrapper);
        var x = parseInt(work.style.left) * -1 + parseInt(pwStyles.paddingLeft);
        var y = parseInt(work.style.top) * -1 + parseInt(pwStyles.paddingTop) + parseInt(work.clientHeight / -1);
        document.removeEventListener("mousemove", onMouseMove);
        eventMouseAdded = false;
        console.log(x, y);
        gsap.to(panningWrapper, {
          duration: 2,
          overwrite: true,
          ease: "power4",
          x: x,
          y: y
        });
      }
    });
    anchor.addEventListener('mouseleave', function (e) {
      work.classList.remove('hover');
    });
    document.querySelector('.main-navigation').addEventListener('mouseleave', function (e) {
      if (!eventMouseAdded) {
        document.addEventListener("mousemove", onMouseMove);
        eventMouseAdded = true;
      }

      onResize();
    }); // window.addEventListener("resize", onResize);
    // document.addEventListener("mousemove", onMouseMove);
  });
}

var shuffle = function shuffle(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref = [array[j], array[i]];
    array[i] = _ref[0];
    array[j] = _ref[1];
  }

  return array;
};

function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}
/*--------------------------------------------------------------
## Video Popup
--------------------------------------------------------------*/


function initVideoPopup() {
  createVideoPopup();
  document.addEventListener("keyup", function (event) {
    console.log(event);

    if (event.code === 'Escape') {
      closeVideoPopup();
    }
  });
}

function createVideoPopup() {
  videoPopup.id = 'video-popup';
  videoContainer.className = 'video-container';
  videoPopupHeader.className = 'popup-header';
  videoPopupContent.className = 'popup-content';
  videoCloseButton.className = 'close-popup'; // videoIframe.setAttribute('frameBorder', '0');
  // videoIframe.setAttribute('allow', 'autoplay');
  // videoIframe.setAttribute('allowFullScreen', 'true');

  videoPopup.appendChild(videoCloseButton);
  videoPopup.appendChild(videoPopupContent);
  videoPopupContent.appendChild(videoPopupHeader);
  videoPopupContent.appendChild(videoContainer);
  document.body.appendChild(videoPopup); // vimeo api

  vimeoScript.src = 'https://player.vimeo.com/api/player.js';
  vimeoScript.addEventListener('load', function (e) {
    console.log('vimeo loaded');
  });
  document.body.appendChild(vimeoScript); // events

  videoCloseButton.addEventListener('click', function (e) {
    closeVideoPopup();
  });
}

function openVideoPopup(el) {
  updateVideoPopup(el);
}

function closeVideoPopup(url) {
  if (document.body.classList.contains('video-popup--toggled')) {
    document.body.classList.remove('video-popup--toggled');

    if (_typeof(videoPlayer) == 'object') {
      videoPlayer.destroy();
    }

    history.back();
  }
}

function updateVideoPopup(el) {
  var url = el.dataset.videoUrl ? el.dataset.videoUrl : el.href;
  var id = getVimeoId(url);
  if (!id) return;
  console.log(id);
  var options = {
    id: parseInt(id),
    autoplay: true,
    color: '0500FF',
    title: false
  }; // if (videoPlayer === undefined) {

  videoPlayer = new Vimeo.Player(videoContainer, options); // } else {
  // 	videoPlayer.loadVideo(options.id).then(() => {
  // 		console.log('video loaded');
  // 	});
  // }

  if (el.querySelector('.entry-header')) {
    videoPopupHeader.innerHTML = el.querySelector('.entry-header').innerHTML;
  }

  var urlObj = new URL(el.href); // const urlState = urlObj.hostname
  // console.log(urlObj);

  history.pushState({}, "", urlObj.pathname);
  document.body.classList.add('video-popup--toggled');
  console.log('content updated');
}

function getVimeoId(url) {
  var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
  var parseUrl = url.match(regExp);
  return parseUrl[5];
}
/*--------------------------------------------------------------
## Director Popup
--------------------------------------------------------------*/


function initDirectorPopup() {
  createDirectorPopup();
}

function createDirectorPopup() {
  directorPopup.id = 'director-popup';
  directorPopupHeader.className = 'popup-header';
  directorPopupContent.className = 'popup-content';
  directorCloseButton.className = 'close-popup';
  directorPopup.appendChild(directorCloseButton);
  directorPopup.appendChild(directorPopupContent);
  directorPopup.appendChild(directorPopupHeader);
  document.body.appendChild(directorPopup);
  directorCloseButton.addEventListener('click', function (e) {
    closeDirectorPopup(); // console.log('click');
  });
}

function openDirectorPopup(link) {
  document.body.classList.add('loading-popup');
  fetch(link.href).then(function (response) {
    // The API call was successful!
    return response.text();
  }).then(function (html) {
    // Convert the HTML string into a document object
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    document.body.classList.remove('loading-popup');
    document.body.classList.add('director-popup--toggled');
    updateDirectorPopup(doc.querySelector('.site-main').innerHTML); // setTimeout(() => {
    // }, 100);
  }).catch(function (err) {
    console.warn('Something went wrong.', err);
  });
}

function closeDirectorPopup() {
  if (document.body.classList.contains('director-popup--toggled') && !document.body.classList.contains('video-popup--toggled')) {
    document.body.classList.remove('director-popup--toggled');
    document.body.classList.remove('director-description-toggled');
  } // history.back();

}

function updateDirectorPopup(content) {
  directorPopupContent.innerHTML = content;
  directorPopup.scrollTo(0, 0);
  projectLoopInit(directorPopup); // console.log('popup director updated');
  // setTimeout(() => {
  // return true;
  // }, 1000);
}

function videoLinksInit() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var videoLinks = container.querySelectorAll('a[data-video-url]');
  videoLinks.forEach(function (el, i) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openVideoPopup(el);
    });
  });
}

function animateProject(project) {
  gsap.to(project, {
    left: getProjectPosX(project),
    top: getProjectPosY(project),
    duration: .5,
    opacity: 1,
    scale: 1
  });
}

function projectLoopInit() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

  // if (!document.body.classList.contains('home') && !document.body.classList.contains('archive')) {
  // animProjectList();
  // } else {
  if (window.innerWidth < mobileBP) {
    animProjectList();
  } else {
    // let j = 0;
    var projects = container.querySelectorAll('.loop-container .type-project');
    projects.forEach(function (project, i) {
      gsap.set(project, {
        opacity: 0,
        left: '50%',
        top: '50%'
      }); // console.log(project.querySelector('img'));

      var projectImage = project.querySelector('img');

      if (projectImage) {
        if (projectImage.complete) {
          animateProject(project);
        } else {
          projectImage.addEventListener('load', function (e) {
            // console.log('image loaded', projects.length);
            animateProject(project);
          });
        }
      } else {
        animateProject(project);
      }
    });
  } // }


  videoLinksInit(container);

  function animProjectList() {
    container.querySelectorAll('.loop-container .type-project').forEach(function (project, i) {
      var image = project.querySelector('.post-thumbnail img');
      var header = project.querySelector('.entry-header');
      var link = project.querySelector('.link');
      if (!image) return;
      gsap.to(image, {
        y: '-10%',
        scrollTrigger: {
          scroller: container,
          trigger: image,
          scrub: true
        }
      });
      gsap.set(header, {
        // opacity: .5,
        gap: '0',
        x: '-2em'
      });
      gsap.to(header, {
        // gap: 0,
        x: 0,
        // opacity: 1,
        scrollTrigger: {
          scroller: container,
          trigger: header,
          scrub: true
        }
      });
    });
    container.querySelectorAll('.archive-description').forEach(function (el, i) {
      // console.log('descr');
      var image = el.querySelector('img');
      var description = el.querySelector('.description');
      if (!image || !description) return;
      gsap.from(image, {
        opacity: 0,
        scale: .95,
        scrollTrigger: {
          scroller: container,
          trigger: image // scrub: true,

        }
      });
      gsap.from(description, {
        opacity: 0,
        scrollTrigger: {
          scroller: container,
          trigger: description // scrub: true,

        }
      });
    });
  }
}
/*--------------------------------------------------------------
## Get coordinates
--------------------------------------------------------------*/


function getProjectPosX(project) {
  var x = parseInt(project.dataset.x);
  var width = parseInt(project.clientWidth); // console.log('getProjectPosX', x);

  return "calc(".concat(x, "% + ").concat(width * 0.5, "px - ").concat(width * x / 100, "px)");
}

function getProjectPosY(project) {
  var y = parseInt(project.dataset.y);
  var height = parseInt(project.clientHeight); // console.log('getProjectPosY', y);

  return "calc(".concat(y, "% + ").concat(height * 0.5, "px - ").concat(height * y / 100, "px)");
}
/*--------------------------------------------------------------
## About Animation
--------------------------------------------------------------*/


var scrollDuration = 6000;
var ease = "none";

function textAnimScroll() {
  setTimeout(function () {
    animText();
    animPics();
  }, 100);
}
/*--------------------------------------------------------------
## Animate Text About
--------------------------------------------------------------*/


function animText() {
  document.querySelectorAll('.text-anim-container').forEach(function (tac) {
    console.log('tac', tac);
    var st = {
      scrollTrigger: {
        trigger: "body",
        end: "+=".concat(scrollDuration),
        pin: ".site-main",
        // pin: true,
        scrub: 2
      },
      defaults: {
        ease: ease
      }
    };
    var tl = gsap.timeline(st);
    tac.querySelectorAll('.text-anim-scroll').forEach(function (el) {
      // console.log('el:', el);
      var j = 0;
      gsap.to(tac, {
        y: -20,
        duration: el.children.length,
        ease: ease
      });

      var _iterator = _createForOfIteratorHelper(el.children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var f = _step.value;
          j++; // console.log(el.children.length);

          f.innerHTML = '<span class="wrapper">' + f.innerHTML + '<span>';
          var wrapper = f.querySelector('.wrapper');

          if (j > 1) {
            tl.from(wrapper, {
              y: '40%',
              opacity: 0,
              duration: 5 // ease: "power4.inOut",

            } // "<-=1"
            );
          }

          if (j < el.children.length) {
            tl.to(wrapper, {
              y: '-40%',
              opacity: 0,
              filter: 'blur(10px)',
              duration: 4 // ease: "power4.inOut",

            }, '+=4');
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      tac.querySelectorAll('.wp-block-button').forEach(function (el) {
        tl.from(el, {
          opacity: 0,
          duration: 1
        }, '+=1');
      });
    }); // tl.timeScale(1.1);
    // console.log(tl.duration());
  });
}
/*--------------------------------------------------------------
## Animate Pics About
--------------------------------------------------------------*/


function animPics() {
  document.querySelectorAll('.pics-anim-container').forEach(function (pac, j) {
    var st = {
      scrollTrigger: {
        trigger: "body",
        start: "top top",
        end: "+=".concat(scrollDuration * 1),
        scrub: 2
      },
      defaults: {
        ease: 'none'
      }
    };
    var tl2 = gsap.timeline(st);
    tl2.to(pac, {
      y: '+=-100%',
      duration: function duration() {
        return pac.querySelectorAll('figure').length;
      }
    }, '0'); // console.log(tl2);
  });
}